/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_View_More_Options_ButtonInputs */



/**
* | output |
* | --- |
* | "View More Options" |
*
* @param {New_Project_View_More_Options_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_view_more_options_button = /** @type {((inputs?: New_Project_View_More_Options_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_View_More_Options_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voir plus d'options")
	if (locale === "de") return /** @type {LocalizedString} */ ("Weitere Optionen anzeigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Visualizza altre opzioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Посмотреть дополнительные параметры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ver más opciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("查看更多选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("その他のオプションを表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अधिक विकल्प देखें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ver mais opções")
	return /** @type {LocalizedString} */ ("View More Options")
});